import { render, staticRenderFns } from "./LearningGroupAddStudentsTableItem.vue?vue&type=template&id=43abe078&"
import script from "./LearningGroupAddStudentsTableItem.vue?vue&type=script&lang=ts&"
export * from "./LearningGroupAddStudentsTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports